export default __webpack_public_path__ + "static/bubble-with-negative-values-8b9c10cdd29174af67d45bbe43815fbd.png";